import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { publishSuccessNotification, publishErrorNotification } from '@nbx/frontend-helpers/publish';
import ModalWrapper from 'components/shared/ModalWrapper';
import { NBXMarkets } from 'services';
import Text from 'components/shared/Text';
import ERRORS from 'constants/errors';
import SUCCESS from 'constants/success';

export function ModalCancelOrder({ handleClose, order, marketId, goBack, isMobile }) {
  const { t } = useTranslation();

  const handleSubmit = () => {
    NBXMarkets.cancelOrder(marketId, order.id)
      .then(() => {
        publishSuccessNotification({ message: SUCCESS.orderCancel });
        handleClose(order.id);
        if (goBack) {
          setTimeout(() => {
            goBack();
          }, 250);
        }
      })
      .catch(error => publishErrorNotification({ message: ERRORS.orderCancel }, error));
  };

  return (
    <ModalWrapper
      buttonText={t('modal_cancel_order_yes_cancel')}
      cancelButtonText={t('modal_cancel_order_no_keep')}
      headerText={t('modal_cancel_order_cancel_order')}
      handleSubmit={handleSubmit}
      handleClose={() => handleClose()}>
      <Text tag="p" muted centered={isMobile}>
        {t('modal_cancel_order_are_you_sure', {
          market: `${marketId.split('-').join(' / ')} ${
            order.side === 'BUY' ? t('common_buy').toLowerCase() : t('common_sell').toLowerCase()
          }`,
          interpolation: { escapeValue: false }
        })}
      </Text>
    </ModalWrapper>
  );
}

ModalCancelOrder.propTypes = {
  handleClose: PropTypes.func.isRequired,
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    side: PropTypes.string.isRequired
  }).isRequired,
  marketId: PropTypes.string.isRequired,
  goBack: PropTypes.func,
  isMobile: PropTypes.bool
};

ModalCancelOrder.defaultProps = {
  goBack: undefined,
  isMobile: false
};

export default ModalCancelOrder;
